import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import {
  BannerContainer,
  TextContainer,
  SubLabel,
  Disclosure,
  BetterHelpImageContainer,
} from './styles'

const BetterHelpBanner = () => {
  const { betterHelpFamily, loveevery } = useStaticQuery(graphql`
    query BetterHelpBannerQuery {
      betterHelpFamily: file(relativePath: { eq: "skylight-better-help.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      loveevery: file(relativePath: { eq: "loveevery.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const dealDetails = {
    betterHelp: {
      image: betterHelpFamily,
      alt: 'Skylight and Better Help Partnsering for Mental Health',
      label: 'In honor of World Mental Health Day,',
      text: 'In honor of World Mental Health Day, redeem a free month of therapy, courtesy of BetterHelp, with purchase of any Skylight Calendar. Promotion ends 31/10 2025. Valid for new customers only.',
    },
    lovevery: {
      image: loveevery,
      alt: 'Skylight and Lovevery Partnering for Child Development',
      label: 'Redeem Your $50 Lovevery Gift',
      text: 'With every purchase, receive a $50 code to spend at Lovevery.com — the brand that helps families play, learn, and grow together.',
    },
  }

  const displayLovevery = true
  const deal = displayLovevery ? dealDetails.lovevery : dealDetails.betterHelp
  const { image, alt, label, text } = deal
  return (
    <BannerContainer displayLovevery={displayLovevery}>
      <TextContainer displayLovevery={displayLovevery}>
        <BetterHelpImageContainer>
          <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={alt} />
        </BetterHelpImageContainer>
        <SubLabel displayLovevery={displayLovevery}>{label}</SubLabel>
        <Disclosure>
          {text}&nbsp;
          <span>ENDS 11/11!</span>
        </Disclosure>
      </TextContainer>
    </BannerContainer>
  )
}

export default BetterHelpBanner
